export default [
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/news/2023/3/tztesttonynewsarticle",
    notificationType: "NewsArticle",
    schoolId: "easterncrk-p",
    title: "TZ test Tony News Article",
    timestamp: "2023-03-07T00:00:00+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/tztesttonyek",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "TZ test Tony EK",
    timestamp: "2023-03-07T01:25:41+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/event-test-three-structured-recurring",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "Event test three structured recurring",
    timestamp: "2023-03-07T02:27:50+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/event-test-struct-recurring",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "Event test struct recurring",
    timestamp: "2023-03-07T02:31:34+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/all-day-recurring-event",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "All day recurring event",
    timestamp: "2023-03-07T02:37:14+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/freeform-recurring-event",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "freeform recurring event",
    timestamp: "2023-03-07T02:39:57+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/freeform-test-two-recurring-event",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "freeform test two recurring event",
    timestamp: "2023-03-07T02:51:25+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/all-day-recurring-event-test-two",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "All day recurring event test two",
    timestamp: "2023-03-07T02:53:34+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/structured-non-recurring-test-four",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "structured non-recurring test four",
    timestamp: "2023-03-07T02:56:18+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/structured-non-recurring-test-five",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "structured non-recurring test five",
    timestamp: "2023-03-07T02:58:36+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/structured-recurring-test-six",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "structured recurring test six",
    timestamp: "2023-03-07T03:02:39+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/luiz_test_non_recurring_event",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "Luiz Test Non Recurring Event",
    timestamp: "2023-03-07T03:04:56+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/structured-non-recurring-test-3-2",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "structured non-recurring Test 3.2",
    timestamp: "2023-03-08T00:06:23+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/structured-recurring-test-3-2",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "structured recurring Test 3.2",
    timestamp: "2023-03-08T00:09:46+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/all-day-non-recurring-test-3-2",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "All day non-recurring Test 3.2",
    timestamp: "2023-03-08T00:16:53+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/all-day-recurring-test-3-2",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "All day recurring Test 3.2",
    timestamp: "2023-03-08T00:24:11+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/freeform-recurring-test-3-2",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "FreeForm recurring Test 3.2",
    timestamp: "2023-03-08T00:27:41+11:00",
  },
  {
    notificationId:
      "/content/doe/sws/schools/e/easterncrk-p/www/events/2023/3/freeform-non-recurring-test-3-2",
    notificationType: "Event",
    schoolId: "easterncrk-p",
    title: "FreeForm non-recurring Test 3.2",
    timestamp: "2023-03-08T00:30:31+11:00",
  },
];
